import * as React from 'react';
import * as I18n from 'i18n-js';
import gql from 'graphql-tag';
import {
  ListingsCollection,
  ExternalProps as IListingCollectionProps,
} from './listings_collection';

import {
  CommonsWatchedListings,
} from '../rql';

import { CTA } from '../tracker';

import CoreLink from './core_link';
import withListings from '../with_listings';
import { withUserContext, IUserContext } from './user_context_provider';

const COMPONENT_NAME = 'WatchRow';
const MAX_COUNT = 12;
const MIN_COUNT = 4;

type IProps = IListingCollectionProps & IUserContext;

const WatchedListings = withUserContext(withListings<CommonsWatchedListings.Query, CommonsWatchedListings.Variables, IProps>({
  query: gql`
    query Commons_WatchedListings($limit: Int) {
      me {
        watches(input: {
          limit: $limit
          listingsState: LIVE
        }) {
          nodes {
            listing {
              ... ListingsCollection
              ... LoggedInFields
            }
          }
        }
      }
    }
    ${ListingsCollection.fragments.listing}
    ${ListingsCollection.fragments.loggedInFields}
  `,
  options: ownProps => ({
    skip: !!ownProps.user?.loggedOut,
    variables: { limit: MAX_COUNT },
  }),
  extractListings: (data) => {
    return (
      data.me?.watches?.nodes ?? []
    ).map(n => n.listing);
  },
  shouldRender: (data) => {
    if (data.loading) {
      return false;
    }

    const listings = data.me?.watches?.nodes ?? [];
    return listings.length >= MIN_COUNT;
  },
  buildDefaultProps: () => {
    return {
      callToAction: (
        <CoreLink
          to={'/watched_products'}
          interactionType={CTA}
        >
          {I18n.t('commons.watchRow.cta')}
        </CoreLink>
      ),
      componentName: COMPONENT_NAME,
      title: I18n.t('commons.watchRow.title'),
      largeTiles: true,
    };
  },
}));

export default WatchedListings;



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/src/components/watched_listings.tsx